export default "__VITE_ASSET__C2ZwiJV9__"